import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.src = 'images/hero.mp4';
      video.onended = () => {
        video.playbackRate = video.playbackRate > 0 ? -1 : 1;
        video.play();
      };
    }
  }, []);

  // Varianty pro postupné načítání textu (Stagger)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Rozestup mezi řádky textu
        delayChildren: 0.5    // Počkáme půl sekundy, než začneme
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30, filter: "blur(10px)" },
    visible: { 
      opacity: 1, 
      y: 0, 
      filter: "blur(0px)",
      transition: { duration: 1.2, ease: "easeOut" }
    }
  };

  return (
    <section className="hero" id="home" style={{ position: 'relative', overflow: 'hidden' }}>
      <video 
        ref={videoRef} 
        autoPlay 
        muted 
        playsInline 
        style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
      ></video>
      
      {/* Overlay pro ztmavení videa, aby text lépe vynikl */}
      <div style={{
        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
        background: 'rgba(0,0,0,0.3)', zIndex: 1
      }}></div>

      <motion.div 
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        style={{ zIndex: 2, position: 'relative' }}
      >
        <motion.p 
          variants={itemVariants}
          style={{ fontStyle: 'italic', fontSize: '1.2rem', letterSpacing: '2px' }}
        >
          Tvořím z lásky k materiálu a řemeslu..
        </motion.p>
        
        <motion.h1 
          variants={itemVariants}
          style={{ fontSize: '5rem', margin: '10px 0', fontWeight: '800' }}
        >
          Václav Kolářík
        </motion.h1>
        
        <motion.h2 
          variants={itemVariants}
          style={{ fontSize: '2rem', fontWeight: '300', textTransform: 'uppercase', letterSpacing: '4px' }}
        >
          Sochař a umělecký řezbář
        </motion.h2>

        {/* Bonus: Scroll indikátor (šipka dolů) */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 1 }}
          style={{ marginTop: '50px' }}
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 2 }}
            style={{ fontSize: '2rem', color: '#fff' }}
          >
            ↓
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;